module.exports = __webpack_public_path__ + "static/images/card-new.5e4b299.png";